import { Link, useSearchParams } from 'react-router-dom'
import { useState, useEffect, useRef } from 'react';
import { usePagination } from '../../contexts/PaginationContext';
import { useNotification } from '../../contexts/NotificationContext';
import { useUserAPI } from '../../contexts/UserAPIContext';
import PaginationControls from '../../components/PaginationControls';
import AvisosTable from '../../components/AvisosTable';
import Footer from '../../components/Footer';
import { authFetch } from '../../utils/authFetch';
import 'bootstrap-icons/font/bootstrap-icons.css';

const Avisos = () => {
  const [searchParams] = useSearchParams();
  const userIdFromUrl = searchParams.get('userId');
  const { userAPIData } = useUserAPI();
  const [avisos, setAvisos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [searchTerm, setSearchTerm] = useState('');
  const [searchTimeout, setSearchTimeout] = useState(null);
  const [verMeusAvisos, setVerMeusAvisos] = useState(!!userIdFromUrl);
  const isFirstRequest = useRef(true);

  const { showNotification } = useNotification();

  const {
    page,
    pageSize,
    setTotalElements,
    setTotalPages,
    setPage,
  } = usePagination();

  const handleSearch = (event) => {
    const value = event.target.value;
    setSearchTerm(value);

    if (searchTimeout) {
      clearTimeout(searchTimeout);
    }

    if (value.length >= 3 || value.length === 0) {
      const timeoutId = setTimeout(() => {
        isFirstRequest.current = true; // Reset para primeira requisição na busca
        fetchAvisos(value);
      }, 500);
      setSearchTimeout(timeoutId);
    }
  };

  const fetchAvisos = async (description = searchTerm) => {
    try {
      setLoading(true);
      const currentPage = isFirstRequest.current ? 0 : page;
      const queryParams = new URLSearchParams();
      if (description && description.length >= 3) {
        queryParams.append('description', description);
      }
      if (verMeusAvisos && userAPIData && userAPIData.id) {
        queryParams.append('userId', userAPIData.id);
      }
      
      const url = `notification/${currentPage}/${pageSize}${queryParams.toString() ? '?' + queryParams.toString() : ''}`;
      const response = await authFetch(url);

      if (!response.ok) throw new Error("Erro ao buscar avisos");

      const data = await response.json();
      setAvisos(data.content);
      setTotalElements(data.totalElements || 0);
      setTotalPages(data.totalPages || 0);
      
      // Atualiza a página após o request
      setPage(currentPage);
      isFirstRequest.current = false;
    } catch (err) {
      setError(err.message);
      showNotification("danger", "Erro ao carregar avisos");
    } finally {
      setLoading(false);
    }
  };

  const handleVerMeusAvisos = (e) => {
    setVerMeusAvisos(e.target.checked);
    isFirstRequest.current = true;
    setPage(0);
  };

  useEffect(() => {
    isFirstRequest.current = true;
    fetchAvisos();
  }, [page, pageSize, verMeusAvisos, userAPIData]);

  if (error) return <p>Erro: {error}</p>;

  return (
    <div className="content">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <h3 className="font-weight-bolder mb-0">Avisos</h3>
        <div className="d-flex flex-wrap gap-2 align-items-center">
          <Link to={'Novo'} className='btn btn-info btn-sm'>Cadastrar Aviso</Link>
        </div>
      </div>
      <div className="card">
        <div className="card-body p-3">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="verMeusAvisos"
                checked={verMeusAvisos}
                onChange={handleVerMeusAvisos}
              />
              <label className="form-check-label" htmlFor="verMeusAvisos">
                Ver meus avisos
              </label>
            </div>
            <div className="input-group" style={{ maxWidth: '300px' }}>
              <span className="input-group-text border-0 bg-transparent">
                <i className="bi bi-search text-secondary"></i>
              </span>
              <input
                type="text"
                className="form-control border-start-0 ps-0"
                placeholder="Buscar por descrição..."
                value={searchTerm}
                onChange={handleSearch}
              />
            </div>
          </div>

          <AvisosTable 
            avisos={avisos}
            loading={loading}
          />

          <PaginationControls currentCount={avisos.length} />
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Avisos